<template>
  <div class="report-crime">
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <b-card header="Report Crime">
      <b-form @submit.prevent="submitReport">
        <b-row>
          <b-col md="6" class="mb-3">
            <b-form-group label="Reporting Level">
              <b-form-select v-model="form.CRtype" :options="crTypeOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mb-3">
            <b-form-group label="Crime Type">
              <b-form-select v-model="form.crimeType" :options="crimeTypeOptions" required></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="form.CRtype === 'online'">
          <b-col md="4" class="mb-3">
            <b-form-group label="Source">
              <b-form-select v-model="form.source" :options="sourceOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="URL">
              <b-form-input v-model="form.url" type="url"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Medium">
              <b-form-input v-model="form.medium"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Report Date">
              <b-form-input v-model="form.reportDate" type="date" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Latitude">
              <b-form-input v-model="form.lat" type="number" step="any" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Longitude">
              <b-form-input v-model="form.lon" type="number" step="any" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Known Species?">
              <b-form-radio-group v-model="form.knownSpecies" :options="yesNoOptions" required></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes'">
            <b-form-group label="Included in Digital Guide?">
              <b-form-radio-group v-model="form.includeinSpecies" :options="yesNoOptions" required></b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes' && form.includeinSpecies === 'yes'">
            <b-form-group label="Select Species">
              <b-form-select v-model="form.species" :options="speciesOptions" required></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3" v-if="form.knownSpecies === 'yes' && form.includeinSpecies === 'no'">
            <b-form-group label="Species Name">
              <b-form-input v-model="form.speciesName" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Description" class="mb-3">
          <b-form-textarea v-model="form.description" rows="3"></b-form-textarea>
        </b-form-group>

        <h5 class="mt-4 mb-3">Contributor Details (Optional)</h5>
        <b-row>
          <b-col md="4" class="mb-3">
            <b-form-group label="Name">
              <b-form-input v-model="form.contributorName"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Email">
              <b-form-input v-model="form.contributorEmail" type="email"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4" class="mb-3">
            <b-form-group label="Phone">
              <b-form-input v-model="form.contributorPhone"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <h5 class="mt-4 mb-3">Accused / Offender Details</h5>
        <b-row class="mb-3">
          <b-col cols="12">
            <b-form-group label="Link Accused from Database">
              <div class="accused-selection-box border rounded p-4 bg-white shadow-sm">
                <b-row class="mb-4 align-items-end">
                  <b-col md="6" class="mb-3 mb-md-0">
                    <va-select
                      v-model="selectedOffender"
                      :options="offenderOptions"
                      textBy="displayName"
                      keyBy="_id"
                      searchable
                      @update:search-value="handleSearch"
                      placeholder="Search for an offender by name or alias..."
                    />
                  </b-col>
                  <b-col md="6" class="d-flex flex-column flex-sm-row">
                    <b-button variant="danger" @click.prevent="addAccused" :disabled="!selectedOffender" class="mr-sm-2 mb-2 mb-sm-0 flex-grow-1">
                      <i class="fa fa-plus mr-2"></i> Add Accused
                    </b-button>
                    <b-button variant="outline-danger" @click.prevent="showAddOffenderModal = true" class="flex-grow-1">
                      <i class="fa fa-user-plus mr-2"></i> Create New Offender
                    </b-button>
                  </b-col>
                </b-row>

                <div v-if="selectedOffendersList && selectedOffendersList.length" class="accused-list mt-3">
                  <div v-for="(item, index) in selectedOffendersList" :key="index" class="accused-item-row p-3 mb-2 rounded border d-flex align-items-center justify-content-between bg-light">
                    <div class="d-flex align-items-center">
                      <div class="avatar-circle mr-3 bg-secondary text-white shadow-sm" style="width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
                        <i class="fa fa-user"></i>
                      </div>
                      <div>
                        <p class="mb-0 font-weight-bold">{{ item.displayName }}</p>
                        <small class="text-muted" v-if="item.age">Age: {{ item.age }}</small>
                      </div>
                    </div>
                    <b-button variant="link" class="text-danger p-0" @click.prevent="removeAccused(index)">
                      <i class="fa fa-times-circle fa-lg"></i>
                    </b-button>
                  </div>
                </div>
                <div v-else class="text-center py-5 border rounded bg-light border-dashed">
                  <i class="fa fa-users fa-3x text-light mb-3"></i>
                  <p class="text-muted mb-0">No accused linked to this crime report yet.</p>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <h5 class="mt-4 mb-3">Media Uploads</h5>
        <b-row>
          <b-col md="3" class="mb-3">
            <b-form-group label="Photos">
              <b-form-file multiple accept="image/*" v-model="files.photos"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Videos">
              <b-form-file multiple accept="video/*" v-model="files.videos"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Audio Clips">
              <b-form-file multiple accept="audio/*" v-model="files.audioClips"></b-form-file>
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-3">
            <b-form-group label="Documents">
              <b-form-file multiple accept=".pdf,.doc,.docx" v-model="files.documents"></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="mt-4 text-center">
          <b-button type="submit" variant="primary" size="lg">Submit Crime Report</b-button>
        </div>
      </b-form>
    </b-card>
    <!-- Add Offender Modal -->
    <AddOffenderModal
      v-model="showAddOffenderModal"
      @saved="handleOffenderSaved"
    />
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
import AddOffenderModal from '../Offenders/AddOffenderModal'

export default {
  name: 'ReportCrime',
  components: {
    VueElementLoading,
    AddOffenderModal,
  },
  data () {
    return {
      visible: false,
      form: {
        CRtype: 'groundlevel',
        crimeType: null,
        knownSpecies: 'no',
        includeinSpecies: 'no',
        species: null,
        speciesName: '',
        source: null,
        url: '',
        medium: '',
        description: '',
        reportDate: '',
        lat: '',
        lon: '',
        anonymous: 'no', // For admin/analyst submitting directly
        contributorName: '',
        contributorEmail: '',
        contributorPhone: '',
      },
      files: {
        photos: [],
        videos: [],
        audioClips: [],
        documents: [],
      },
      crTypeOptions: [
        { value: 'groundlevel', text: 'Field Reporting' },
        { value: 'online', text: 'Online Reporting' },
      ],
      yesNoOptions: [
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' },
      ],
      crimeTypeOptions: [],
      sourceOptions: [],
      speciesOptions: [],
      selectedOffender: '',
      offenderOptions: [],
      selectedOffendersList: [],
      showAddOffenderModal: false,
      searchTimeout: null,
    }
  },
  mounted () {
    this.fetchData()
    this.getOffenders()
  },
  methods: {
    async fetchData () {
      this.visible = true
      try {
        const [ctRes, srcRes, spRes] = await Promise.all([
          axios.get('/crimetype/list', { headers: { token: localStorage.getItem('token') } }),
          axios.post('/source/list', {}, { headers: { token: localStorage.getItem('token') } }),
          axios.post('/species/list', {}, { headers: { token: localStorage.getItem('token') } }),
        ])

        if (ctRes.data.status) {
          this.crimeTypeOptions = ctRes.data.data.map(c => ({ value: c._id, text: c.cname }))
        }
        if (srcRes.data.status) {
          this.sourceOptions = srcRes.data.data.map(s => ({ value: s._id, text: s.sname }))
        }
        if (spRes.data.status) {
          this.speciesOptions = spRes.data.data.map(s => ({ value: s._id, text: s.commonName || s.scientificName }))
        }
      } catch (err) {
        console.error('Failed to load form options:', err)
      } finally {
        this.visible = false
      }
    },
    async submitReport () {
      this.visible = true

      const formData = new FormData()
      Object.keys(this.form).forEach(key => {
        if (this.form[key]) {
          formData.append(key, this.form[key])
        }
      })
      formData.append('anonymous', 'no') // Ensure analyst is tracked

      // Append offenders list
      const offenderIds = this.selectedOffendersList.map(o => o._id)
      formData.append('offenders', JSON.stringify(offenderIds))

      // Append files
      Object.keys(this.files).forEach(key => {
        if (this.files[key] && this.files[key].length > 0) {
          for (let i = 0; i < this.files[key].length; i++) {
            formData.append(key, this.files[key][i])
          }
        }
      })

      try {
        const response = await axios.post('/crimereport/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            token: localStorage.getItem('token'),
          },
        })

        if (response.data.status) {
          alert('Crime reported successfully!')
          this.$router.push('/dashboard')
        } else {
          alert(response.data.msg || 'Failed to report crime')
        }
      } catch (err) {
        console.error(err)
        alert('An error occurred during submission.')
      } finally {
        this.visible = false
      }
    },
    getOffenders (search = '') {
      const params = search ? { search } : {}
      axios({
        method: 'GET',
        url: '/offenders/list',
        params,
        headers: { token: localStorage.getItem('token') },
      }).then((res) => {
        if (res.data.status && Array.isArray(res.data.data)) {
          this.offenderOptions = res.data.data.map(o => {
            const name = o.name || 'Unknown'
            const alias = o.alias ? ` (${o.alias})` : ''
            return {
              ...o,
              displayName: name + alias,
            }
          })
        }
      }).catch(err => {
        console.error('Error fetching offenders:', err)
      })
    },
    handleSearch (val) {
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.getOffenders(val)
      }, 500)
    },
    addAccused () {
      if (!this.selectedOffender) return

      const offenderId = (this.selectedOffender && this.selectedOffender._id)
        ? this.selectedOffender._id
        : this.selectedOffender

      if (!offenderId) return

      // Check for duplicates
      const exists = this.selectedOffendersList.some(o => String(o._id) === String(offenderId))

      if (exists) {
        this.$dlg.alert('This offender is already added to the list.')
        return
      }

      // Add full object
      const fullOffender = typeof this.selectedOffender === 'object'
        ? this.selectedOffender
        : this.offenderOptions.find(o => String(o._id) === String(offenderId))

      if (fullOffender) {
        this.selectedOffendersList.push(fullOffender)
      }
      this.selectedOffender = ''
    },
    removeAccused (index) {
      this.selectedOffendersList.splice(index, 1)
    },
    handleOffenderSaved (savedOffender) {
      this.offenderOptions.push(savedOffender)
      this.selectedOffender = savedOffender
      this.addAccused()
    },
  },
}
</script>

<style scoped>
.report-crime {
  padding: 20px;
}
</style>
